module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingtime"
  }, [_c('p', {
    staticClass: "meetingtime__time"
  }, [_vm._v(_vm._s(_vm.time))]), _c('p', {
    staticClass: "meetingtime__address"
  }, [_vm._v(_vm._s(_vm.address))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c9f006","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/timeandaddress/MentoringTimeMeeting.vue
// module id = 81260932f2fef413b70a
// module chunks = 89